/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Contract_Prepaid_HintInputs */



/**
* | output |
* | --- |
* | "This replaces the plan's monthly AI allowance for the whole term." |
*
* @param {Partner_Add_Contract_Prepaid_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_prepaid_hint = /** @type {((inputs?: Partner_Add_Contract_Prepaid_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Prepaid_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Budget ersetzt das monatliche KI-Guthaben des Tarifs für die gesamte Laufzeit.")
	return /** @type {LocalizedString} */ ("This replaces the plan's monthly AI allowance for the whole term.")
});